import { useEffect, useState } from "react";
import { getRecordTypeList } from "utils/api/lookupApi";
import { OptionRenderType } from "controls/global/stewart-checkbox/StewartAutocompleteWithCheckboxes";

// Record-type dropdown options sourced from /lookup/GetPIListAsync/RecordType.
// Label = RecordTypeName, value = RecordTypeCode (preserves the existing
// single-letter wire format on the RecordTypeCode filter).
export function useRecordTypeOptions(): OptionRenderType[] {
  const [options, setOptions] = useState<OptionRenderType[]>([]);
  useEffect(() => {
    let mounted = true;
    getRecordTypeList()
      .then((rows) => {
        if (!mounted) return;
        const list = Array.isArray(rows) ? rows : [];
        setOptions(
          list.map((r) => ({ label: r.RecordTypeName, value: r.RecordTypeCode }))
        );
      })
      .catch(() => {
        if (mounted) setOptions([]);
      });
    return () => {
      mounted = false;
    };
  }, []);
  return options;
}
